import EngineModule from '../EngineModule';

export default () => new EngineModule.LogicalEngineModule({
	type :             'logical',
	id :               'header-menu',
	dependencies :     [
		'oms-basket'
	],
	allowedCustomers : null,
	generateComponentConfiguration() {
		return {};
	},
	insertionPath : null
});
